import { throttle } from 'lodash-es';

const SCROLL_EVENT_TROTTLE_TIME = 200;

const clickGlobal = () => {
  const clickAreas = document.querySelectorAll('.j-global-nav__main-logo, .j-global-nav__main-title');
  const bodyNav = document.body;

  for (const clickArea of clickAreas) {
    clickArea.addEventListener('click', () => {
      bodyNav.getAttribute('data-state') === 'global-nav-open'
        ? bodyNav.removeAttribute('data-state')
        : bodyNav.setAttribute('data-state', 'global-nav-open');
    });
  }
};

const closeGlobalOnScroll = () => {
  window.addEventListener(
    'scroll',
    throttle(() => {
      const intViewportWidth = window.innerWidth;
      const isGlobalOpen = document.querySelector('body').getAttribute('data-state') === 'global-nav-open';

      if (isGlobalOpen && intViewportWidth >= 768) {
        const globalNav = document.querySelector('.j-global-nav');
        const globalPosition = globalNav.offsetHeight + globalNav.getBoundingClientRect().y;

        if (globalPosition <= 0) {
          document.querySelector('body').setAttribute('data-state', '');
        }
      }
    }, SCROLL_EVENT_TROTTLE_TIME)
  );
};

export const init = () => {
  clickGlobal();
  closeGlobalOnScroll();
};
